module.exports = __webpack_public_path__ + "img/skiing002.7110540f.jpg";